import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useJobPosting} from '../../hooks/useJobPosting';
import JobPostingStep1 from '../../components/job/JobPostingStep1';
import JobPostingStep2 from '../../components/job/JobPostingStep2';
import ConfirmModal from '../../components/job/ConfirmModal';
import {getJobPostingSettings} from "../../api/jobApi";
import {JobPostingSettings} from "../../interface/JobPostingSettings";

const JobCareApplyPage = () => {
    const navigate = useNavigate();
    const jobPosting = useJobPosting('CARE'); // 간병인
    const [settings, setSettings] = useState<JobPostingSettings | null>(null);

    useEffect(() => {
        jobPosting.fetchSeniors();

        // 설정값 가져오기
        const fetchSettings = async () => {
            try {
                const response = await getJobPostingSettings();
                setSettings(response.data);
            } catch (error) {
                console.error('설정값 로딩 실패:', error);
            }
        };
        fetchSettings();
    }, []);

    // settings 값으로 동적 guideList 생성
    const guideList = settings ? [
        `서비스 3일전 ${settings.penalty3daysBefore}%`,
        `서비스 2일전 ${settings.penalty2daysBefore}%`,
        `서비스 1일전 ${settings.penalty1dayBefore}%`,
        // `서비스 시작일 당일 : ${settings.penaltySameDay}%`,
    ] : [
        '서비스 3일전 10%',
        '서비스 2일전 20%',
        '서비스 1일전 30%',
        // '서비스 시작일 당일 : 50%',
    ];

    useEffect(() => {
        jobPosting.fetchSeniors();
    }, []);

    return (
        <>
            {jobPosting.step === 1 && (
                <JobPostingStep1
                    form={jobPosting.form}
                    seniors={jobPosting.seniors}
                    onFormChange={jobPosting.setForm}
                    onSeniorChange={jobPosting.handleSeniorChange}
                    onNextStep={jobPosting.onNextStep}
                    onCancel={() => navigate(-1)}
                />
            )}

            {jobPosting.step === 2 && (
                <>
                    <JobPostingStep2
                        form={jobPosting.form}
                        onFormChange={jobPosting.setForm}
                        questionList={jobPosting.questionList}
                        answers={jobPosting.answers}
                        onAnswerChange={jobPosting.handleAnswerChange}
                        onPrevStep={() => jobPosting.setStep(1)}
                        onSubmit={jobPosting.handleOpenModal}
                    />

                    <ConfirmModal
                        isOpen={jobPosting.isModalOpen}
                        title="주의사항 안내"
                        message="공고 등록 후 코디와 매칭 시 서비스가 예약됩니다. 예약 완료 후 예약 취소를 하시는 경우 위약금이 아래와 같이 발생하며 예약 취소 시 결제된 급여 금액에서 위약금을 차감 후 환원되오니 예약 취소 시 유의하시기 바랍니다."
                        guideList={guideList}
                        onConfirm={jobPosting.handleConfirmSubmit}
                        onClose={jobPosting.handleCloseModal}
                        confirmText="등록"
                        closeText="닫기"
                    />
                </>
            )}
        </>
    );
};

export default JobCareApplyPage;